// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ClaimItem_card__IY\\+a6:not(:last-child) {
  margin-bottom: 12px;
}

.ClaimItem_status-date__01hmk {
  font-weight: 500;
}

.ClaimItem_last-comment__0qayN {
  margin-bottom: 12px;
  font-size: 16px;
  line-height: 28px;
}

.ClaimItem_comment__qJXyK {
  padding: 12px 0;
  border-top: 2px solid #fff;
}
.ClaimItem_comment__qJXyK:last-child {
  padding-bottom: 0;
}
.ClaimItem_comment__qJXyK * {
  font-size: 14px;
  line-height: 24px;
}

.ClaimItem_comments-link__anHRO {
  width: 100%;
  margin-top: 12px;
  text-align: center;
  font-size: 16px;
  font-weight: 300;
  line-height: 28px;
}

.ClaimItem_collapsible-title__Ghe53 {
  margin-left: 8px;
}

.ClaimItem_summary-first-line__W8Drn {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.ClaimItem_circumstances__6dgZZ:not(:last-child) {
  margin-bottom: 12px;
}

.ClaimItem_document-link__x2IG7 {
  line-height: 1;
}

.ClaimItem_button__WWWIj {
  width: 200px;
  margin: 32px auto 0;
}

.ClaimItem_light__Yl82V {
  font-weight: 300;
}

.ClaimItem_required-documents__dhjvT {
  color: #000093;
  padding-top: 10px;
  display: block;
}
.ClaimItem_required-documents__dhjvT ul {
  padding: 0;
  margin: 5px 0 0 0;
}
.ClaimItem_required-documents__dhjvT ul li {
  padding: 0;
  font-size: 16px;
  line-height: 28px;
  list-style-type: none;
  display: flex;
  justify-content: space-between;
  padding: 7px 0;
}
.ClaimItem_required-documents__dhjvT ul li:not(:first-child) {
  border-top: 1px solid #d8d8ff;
}
.ClaimItem_required-documents__dhjvT ul li:last-child {
  padding-bottom: 0;
}
.ClaimItem_required-documents__dhjvT ul li.ClaimItem_rejected__odF0Z legend {
  color: #911727;
}
.ClaimItem_required-documents__dhjvT ul li.ClaimItem_checking__SwOv1 div {
  color: #e78d3d;
}
.ClaimItem_required-documents__dhjvT ul li legend {
  display: flex;
  align-items: center;
}
.ClaimItem_required-documents__dhjvT ul li div {
  min-width: max-content;
  display: flex;
  align-items: center;
  color: #1414ff;
  margin-left: 10px;
}
.ClaimItem_required-documents__dhjvT ul li svg {
  margin-right: 6px;
}

.ClaimItem_eye__DpM\\+\\+ {
  margin-right: 0 !important;
}

.ClaimItem_infoMessage__G-zf8 {
  margin-bottom: 12px;
}

@media screen and (max-width: 900px) {
  .ClaimItem_incomplete__D1Az6 {
    flex-direction: column;
    gap: 12px;
  }
  .ClaimItem_incomplete__D1Az6 .ClaimItem_last-comment__0qayN {
    width: 100%;
    margin: 0;
  }
  .ClaimItem_incomplete__D1Az6 .ClaimItem_upload__tuN0K {
    width: 100%;
  }
  .ClaimItem_incomplete__D1Az6 .ClaimItem_upload-button__9kKsg {
    height: 46px;
  }
  .ClaimItem_summary-first-line__W8Drn {
    flex-direction: column;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Claims/ClaimItem/ClaimItem.module.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAIE;EACE,mBAAA;AAGJ;;AACA;EACE,gBAAA;AAEF;;AACA;EACE,mBAAA;EACA,eAAA;EACA,iBAAA;AAEF;;AACA;EACE,eAAA;EACA,0BAAA;AAEF;AAAE;EACE,iBAAA;AAEJ;AACE;EACE,eAAA;EACA,iBAAA;AACJ;;AAGA;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AAAF;;AAIE;EACE,mBAAA;AADJ;;AAKA;EACE,cAAA;AAFF;;AAKA;EACE,YAAA;EACA,mBAAA;AAFF;;AAKA;EACE,gBAAA;AAFF;;AAMA;EACE,cCpES;EDqET,iBAAA;EACA,cAAA;AAHF;AAKE;EACE,UAAA;EACA,iBAAA;AAHJ;AAKI;EACE,UAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,aAAA;EACA,8BAAA;EACA,cAAA;AAHN;AAKM;EACE,6BAAA;AAHR;AAMM;EACE,iBAAA;AAJR;AAOM;EACE,cCrEE;ADgEV;AAQM;EACE,cChFK;AD0Eb;AASM;EACE,aAAA;EACA,mBAAA;AAPR;AAUM;EACE,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,cChHG;EDiHH,iBAAA;AARR;AAWM;EACE,iBAAA;AATR;;AAeA;EACE,0BAAA;AAZF;;AAeA;EACE,mBAAA;AAZF;;AAgBA;EACE;IACE,sBAAA;IACA,SAAA;EAbF;EAeE;IACE,WAAA;IACA,SAAA;EAbJ;EAgBE;IACE,WAAA;EAdJ;EAgBI;IACE,YAAA;EAdN;EAmBA;IACE,sBAAA;EAjBF;AACF","sourcesContent":["@use 'styles/colors.scss';\n@use 'styles/sizes.scss';\n\n.card {\n  &:not(:last-child) {\n    margin-bottom: 12px;\n  }\n}\n\n.status-date {\n  font-weight: 500;\n}\n\n.last-comment {\n  margin-bottom: 12px;\n  font-size: 16px;\n  line-height: 28px;\n}\n\n.comment {\n  padding: 12px 0;\n  border-top: 2px solid #fff;\n\n  &:last-child {\n    padding-bottom: 0;\n  }\n\n  & * {\n    font-size: 14px;\n    line-height: 24px;\n  }\n}\n\n.comments-link {\n  width: 100%;\n  margin-top: 12px;\n  text-align: center;\n  font-size: 16px;\n  font-weight: 300;\n  line-height: 28px;\n}\n\n.collapsible-title {\n  margin-left: 8px;\n}\n\n.summary-first-line {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.circumstances {\n  &:not(:last-child) {\n    margin-bottom: 12px;\n  }\n}\n\n.document-link {\n  line-height: 1;\n}\n\n.button {\n  width: 200px;\n  margin: 32px auto 0;\n}\n\n.light {\n  font-weight: 300;\n}\n\n\n.required-documents {\n  color: colors.$primary7;\n  padding-top: 10px;\n  display: block;\n  \n  ul{\n    padding: 0;\n    margin: 5px 0 0 0;\n\n    li {\n      padding: 0;\n      font-size: 16px;\n      line-height: 28px;\n      list-style-type: none;\n      display: flex;\n      justify-content: space-between;\n      padding: 7px 0;\n\n      &:not(:first-child){\n        border-top: 1px solid colors.$primary2;\n      }\n\n      &:last-child{\n        padding-bottom: 0;\n      }\n\n      &.rejected legend{\n        color: colors.$danger6;\n      }\n\n      &.checking div{\n        color: colors.$attention5;\n      }\n\n      legend{\n        display: flex;\n        align-items: center;\n      }\n\n      div {\n        min-width: max-content;\n        display: flex;\n        align-items: center;\n        color: colors.$primary5;\n        margin-left: 10px;\n      }\n\n      svg{\n        margin-right: 6px;\n      }\n    }\n  }\n}\n\n.eye{\n  margin-right: 0!important;\n}\n\n.infoMessage{\n  margin-bottom: 12px;\n}\n\n\n@media screen and (max-width: sizes.$breakpoint-md) {\n  .incomplete {\n    flex-direction: column;\n    gap: 12px;\n\n    .last-comment {\n      width: 100%;\n      margin: 0;\n    }\n\n    .upload {\n      width: 100%;\n\n      &-button {\n        height: 46px;\n      }\n    }\n  }\n\n  .summary-first-line {\n    flex-direction: column;\n  }\n}\n\n\n","$primary1: #f5f5ff;\n$primary2: #d8d8ff;\n$primary3: #8686ff;\n$primary4: #4343ff;\n$primary5: #1414ff;\n$primary6: #0000c9;\n$primary7: #000093;\n$primary8: #00007a;\n$primary9: #000054;\n$primary10: #00003a;\n$primary11: #000078;\n$blueLogo: #000093;\n\n$neutral1: #fcfcfd;\n$neutral2: #f9f9fa;\n$neutral4: #e0e0e3;\n$neutral8: #838390;\n\n$success1: #f4fced;\n$success5: #58b441;\n$success6: #126f0e;\n\n$attention1: #fef9f0;\n$attention3: #fbd298;\n$attention5: #e78d3d;\n$attention7: #b94402;\n\n$danger1: #fdf1ed;\n$danger2: #f9d9cf;\n$danger3: #f4ada1;\n$danger5: #bd454a;\n$danger6: #911727;\n$danger7: #7c1028;\n\n\n$colabelNeutralLight: #F9F9FA;\n$colabelNeutralMid: #C3C3C9;\n$colabelNeutralDark: #121217;\n\n:export {\n    colabelNeutralLight: $colabelNeutralLight;\n    colabelNeutralMid: $colabelNeutralMid;\n    colabelNeutralDark: $colabelNeutralDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"card": `ClaimItem_card__IY+a6`,
	"status-date": `ClaimItem_status-date__01hmk`,
	"last-comment": `ClaimItem_last-comment__0qayN`,
	"comment": `ClaimItem_comment__qJXyK`,
	"comments-link": `ClaimItem_comments-link__anHRO`,
	"collapsible-title": `ClaimItem_collapsible-title__Ghe53`,
	"summary-first-line": `ClaimItem_summary-first-line__W8Drn`,
	"circumstances": `ClaimItem_circumstances__6dgZZ`,
	"document-link": `ClaimItem_document-link__x2IG7`,
	"button": `ClaimItem_button__WWWIj`,
	"light": `ClaimItem_light__Yl82V`,
	"required-documents": `ClaimItem_required-documents__dhjvT`,
	"rejected": `ClaimItem_rejected__odF0Z`,
	"checking": `ClaimItem_checking__SwOv1`,
	"eye": `ClaimItem_eye__DpM++`,
	"infoMessage": `ClaimItem_infoMessage__G-zf8`,
	"incomplete": `ClaimItem_incomplete__D1Az6`,
	"upload": `ClaimItem_upload__tuN0K`,
	"upload-button": `ClaimItem_upload-button__9kKsg`
};
export default ___CSS_LOADER_EXPORT___;
